// import { ActionTypes } from 'types';
// import { useState } from 'react';

// interface defaultStateInterface {
//     title: string;
//     content: string;
//     data: unknown;
//     disabled: boolean;
//     action: ActionTypes | '';
// }

// const defaultState: defaultStateInterface = {
//     title: '',
//     content: '',
//     data: null,
//     disabled: false,
//     action: '',
// };

// const useModalObj = () => {
//     const [modalObject, setModalObject] = useState(defaultState);

//     const onResetModalObj = () => {
//         setModalObject(defaultState);
//     };

//     return { modalObject, setModalObject, onResetModalObj };
// };

// export default useModalObj;

import { useState } from 'react';
import { ActionTypes } from 'types';

interface defaultStateInterface<T> {
    title: string;
    content: string;
    data: T;
    disabled: boolean;
    loading: boolean;
    action: ActionTypes | '';
}

const useModalObj = <T = unknown>() => {
    const defaultState: defaultStateInterface<T | null> = {
        title: '',
        content: '',
        data: null,
        disabled: false,
        loading: false,
        action: '',
    };

    const [modalObject, setModalObject] = useState<defaultStateInterface<T | null>>(defaultState);

    const onResetModalObj = () => {
        setModalObject(defaultState);
    };

    return { modalObject, setModalObject, onResetModalObj };
};

export default useModalObj;
